/**
 * Created by Xuz on 2020/02/03.
 * xuz@live.cn
 *
 * 在操作SVG同时，同时维护着一个XML，此XML保存着页面上数据内容，其不关心各个图的位置，只关心各个节点之间的关系
 */
class WFXml {
  constructor (workflow) {
    this.workflow = workflow
    this.ctx = this.workflow.parent.$_c
    this.oXml = this.getXmlObject()
    this.dRootElement = this.oXml.createElement('fx-workflow')
    this.oXml.appendChild(this.dRootElement)
    this.dActivitys = this.oXml.createElement('activitys')
    this.dRootElement.appendChild(this.dActivitys)
    this.dRoutes = this.oXml.createElement('routes')
    this.dRootElement.appendChild(this.dRoutes)
    this.dRepeats = this.oXml.createElement('repeats')
    this.dRootElement.appendChild(this.dRepeats)
    this.aEls = []
    this.srcXml = ''
    this.aComments = []
  }

  /**
   * 添加一个全局定义操作类至描述文件中
   */
  addObject (obj) {
    let node = obj.getXmlNode(this.oXml)
    this.dRootElement.appendChild(node)

    this.aEls[obj.uuid()] = node
  }

  /**
   * 添加一个实体，此实体可以是任何一个实体，如起点，终点，子流，普通节点
   * 但不包括路径，路径的维护由另外的方法来实现
   */
  addActivity (activity) {
    let node = activity.getXmlNode(this.oXml)
    this.dActivitys.appendChild(node)
    this.aEls[activity.uuid()] = node
  }

  /**
   * 移除一个实体，此实体可以是任何一个实体，与Add相应
   */
  removeActivity (activity) {
    let uuid = activity.uuid()
    let activityNode = this.getSingleNode(this.dActivitys, 'activity', 'uuid', uuid)
    if (activityNode === null) {
      console.log('WFXml 中没有找到节点: ' + activity.getName())
      return
    }
    this.dActivitys.removeChild(activityNode)
    delete this.aEls[uuid]
  }

  /**
   * 添加一条通道，描述两点间的关系，起点到终点
   */
  addRoute (linker) {
    let node = linker.getXmlNode(this.oXml)
    this.dRoutes.appendChild(node)
    this.aEls[linker.uuid()] = node
  }

  removeRoute (linker) {
    let uuid = linker.uuid()
    let routeNode = this.getSingleNode(this.dRoutes, 'route', 'uuid', uuid)
    if (routeNode == null) {
      console.log('WFXml 中没有找到路径: ' + linker.getName())
      return
    }
    this.dRoutes.removeChild(routeNode)
    delete this.aEls[uuid]
  }

  /**
   * 添加一个自循环描述
   */
  addRepeat (repeater) {
    let node = repeater.getXmlNode(this.oXml)
    this.dRepeats.appendChild(node)
    this.aEls[repeater.uuid()] = node
  }

  /**
   * 移除一个自循环描述
   */
  removeRepeat (repeater) {
    let uuid = repeater.uuid()
    let repeatNode = this.getSingleNode(this.dRepeats, 'repeat', 'uuid', uuid)
    if (repeatNode == null) {
      console.log('WFXml 中没有找到自循环: ' + repeater.getName())
      return
    }
    this.dRepeats.removeChild(repeatNode)
    delete this.aEls[uuid]
  }

  /**
   * 通过uuid来获得其节点
   */
  getNode (uuid) {
    return this.aEls[uuid]
  }

  /**
   * { uuid: item.id, name: item.aliasName, order: 1 }
   * @param comment
   */
  addComment (comment) {
    this.aComments.push(comment)
  }

  setComments (list) {
    this.aComments = []
    for (let i = 0; i < list.length; i++) {
      let item = list[i]
      this.aComments.push({ uuid: item.id, name: item.aliasName, order: i + 1 })
    }
  }

  getComments () {
    return this.aComments
  }

  getCommentsXml () {
    let sb = []
    sb.push('<?xml version="1.0" encoding="GBK"?>')
    sb.push('<comments>')
    for (var i = 0; i < this.aComments.length; i++) {
      var c = this.aComments[i]
      sb.push('<comment uuid="' + c.uuid + '" order="' + c.order + '"><![CDATA[' + c.name + ']]></comment>')
    }
    sb.push('</comments>')
    return sb.join('')
  }

  getXml () {
    return this.oXml
  }

  getSource () {
    // return this.getHeader() + this.dRootElement.xml
    return this.getSrcXml()
  }

  getHeader () {
    return '<?xml version="1.0" encoding="utf-8"?>'
  }

  getRootElement () {
    return this.dRootElement
  }

  getSrcXml () {
    let serializer = new XMLSerializer()
    let xmlString = serializer.serializeToString(this.oXml)
    return xmlString
  }

  unSerial (xId) {
    let ctx = process.env.VUE_APP_CTX_PATH
    if (ctx !== '/' && !ctx.endsWith('/')) {
      ctx = ctx + '/'
    }
    let url = null
    if (xId != null) {
      url = ctx + 'api/1/workflow/design/xml_provider.xml?procId=' + xId
    } else {
      url = ctx + 'api/1/workflow/design/xml_provider.xml?procInsId='
      alert('未实现')
    }
    let doc = this.loadXMLSync(url)
    this.oXml = doc
    this.dRootElement = doc.documentElement
    this.srcXml = this.dRootElement.xml

    if (this.dRootElement === null) {
      alert('流程数据读取不正确，请与管理员联系！')
      return
    }
    let tA = this.dRootElement.getElementsByTagName('activitys')
    if (tA !== null) {
      this.dActivitys = tA[0]
    }
    let tR = this.dRootElement.getElementsByTagName('routes')
    if (tR !== null) {
      this.dRoutes = tR[0]
    }
    let tRe = this.dRootElement.getElementsByTagName('repeats')
    if (tRe !== null) {
      this.dRepeats = tRe[0]
    }

    let nodeActivitys = this.dActivitys.getElementsByTagName('activity')
    for (let i = 0; i < nodeActivitys.length; i++) {
      let nodeActivity = nodeActivitys[i]
      let uuid = nodeActivity.getAttribute('uuid')
      this.aEls[uuid] = nodeActivity

      let nodeSpe = this.getFormAttribute(nodeActivity, 'specialType')
      if (nodeSpe !== null && nodeSpe !== '') {
        this.workflow.getElement(uuid).setWFAttributes('SPECIAL_TYPE', nodeSpe)
      }

      let nodeFT = this.getFormAttribute(nodeActivity, 'flowType')
      if (nodeFT !== null && nodeFT !== '') {
        this.workflow.getElement(uuid).setWFAttributes('FLOW_TYPE', nodeFT)
      }

      let nodeUsers = nodeActivity.getElementsByTagName('user')
      if (nodeUsers.length !== 0) {
        this.workflow.getElement(uuid).setWFAttributes('XML_USER', nodeUsers)
      }

      let nodeDept = nodeActivity.getElementsByTagName('dept')
      if (nodeDept.length !== 0) {
        this.workflow.getElement(uuid).setWFAttributes('XML_DEPT', nodeDept)
      }

      let nodeRoute = nodeActivity.getElementsByTagName('route')
      if (nodeRoute.length !== 0) {
        this.workflow.getElement(uuid).setWFAttributes('XML_ROUTE', nodeRoute[0])
      }
    }

    let nodeRoutes = this.dRoutes.getElementsByTagName('route')
    for (let i = 0; i < nodeRoutes.length; i++) {
      let nodeRoute = nodeRoutes[i]
      let uuid = nodeRoute.getAttribute('uuid')
      this.aEls[uuid] = nodeRoute

      let nodeFT = this.getFormAttribute(nodeRoute, 'flowType')
      if (nodeFT !== null && nodeFT !== '') {
        this.workflow.getElement(uuid).setWFAttributes('ROUTE_TYPE', nodeFT)
      }
    }

    let nodeRepeats = this.dRepeats.getElementsByTagName('repeat')
    for (let i = 0; i < nodeRepeats.length; i++) {
      let nodeRepeat = nodeRepeats[i]
      let uuid = nodeRepeat.getAttribute('uuid')
      this.aEls[uuid] = nodeRepeat

      let nodeFT = this.getFormAttribute(nodeRepeat, 'flowType')
      if (nodeFT !== null && nodeFT !== '') {
        this.workflow.getElement(uuid).setWFAttributes('ROUTE_TYPE', nodeFT)
      }
    }

    let nodeDefine = this.dRootElement.getElementsByTagName('define')[0]
    this.aEls[nodeDefine.getAttribute('uuid')] = nodeDefine

    let nodeDefineUser = nodeDefine.getElementsByTagName('user')
    if (nodeDefineUser.length !== 0) {
      this.workflow.getElement(nodeDefine.getAttribute('uuid')).setWFAttributes('XML_USER', nodeDefineUser)
    }
  }

  getXmlObject () {
    let xmldom = null
    // 判断是否为IE浏览器
    if (window.ActiveXObject) {
      alert('window.ActiveXObject')
      xmldom = new ActiveXObject('Microsoft.XMLDOM')
    } else {
      // 其他浏览器
      try {
        xmldom = document.implementation.createDocument(null, null)
      } catch (ex) {
      }
    }
    if (xmldom == null) {
      alert('您的浏览器不支持XML解析器')
    }
    return xmldom
  }

  loadXMLSync (url) {
    let xhr = new XMLHttpRequest()

    xhr.open('GET', url, false)
    xhr.setRequestHeader('Content-Type', 'text/xml')
    xhr.send()

    return xhr.responseXML
  }

  getFormAttribute (node, name) {
    let atts = node.getElementsByTagName('form-attribute')
    for (let i = 0; i < atts.length; i++) {
      let item = atts[i]
      if (item.getAttribute('name') === name) {
        return item.textContent
      }
    }

    return null
  }

  getSingleNode (parent, childrenTagName, childrenAttrName, childrenAttrValue) {
    let els = parent.getElementsByTagName(childrenTagName)
    for (let i = 0; i < els.length; i++) {
      let el = els[i]
      if (el.getAttribute(childrenAttrName) === childrenAttrValue) {
        return el
      }
    }

    return null
  }
}

export default WFXml
